export const isSubmenu = (item: NavigationLink | Submenu): item is Submenu => item.type === "submenu";
